module.exports = __webpack_public_path__ + "static/media/estackk.529b7be2.png";